// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jSyb","col":"styles_col__3nL2l"};